import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getOrganizationById } from '../../../../utils/api_service/organization';
import type { IOrganization } from '../../interfaces';
import { DEFAULT_DETAIL_TAB, ORGANIZATION_DETAIL_TABS } from '../constants';
import { generateAvatarColorClass, getInitials } from '../functions';
import type { OrganizationDetailTab } from '../interfaces';

export interface IUseOrganizationDetails {
  organizationId: string;
  organization: IOrganization;
  activeTab: OrganizationDetailTab;
  setActiveTab: (tab: OrganizationDetailTab) => void;
  tabs: OrganizationDetailTab[];
  initials: string;
  avatarColorClass: string;
  handleBack: () => void;
}

const EMPTY_ORGANIZATION: IOrganization = {
  id: '',
  organizationName: '',
  primaryDomain: '',
  organizationDomains: [],
  companyLogo: '',
  companyDetails: '',
  perksAndBenefits: '',
  replyEmail: '',
  supportEmail: '',
  supportPhone: '',
  customerId: '',
};

export const useOrganizationDetails = (): IUseOrganizationDetails => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState<OrganizationDetailTab>(DEFAULT_DETAIL_TAB);
  const [organization, setOrganization] = useState<IOrganization>(EMPTY_ORGANIZATION);

  useEffect(() => {
    void getOrganization();
  }, []);

  const getOrganization = async (): Promise<void> => {
    try {
      const res = await getOrganizationById(id);
      if (res.ok) {
        const response = await res.json();
        setOrganization(response);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleBack = (): void => {
    history.push('/organizations');
  };

  return {
    organizationId: id,
    organization,
    activeTab,
    setActiveTab,
    tabs: ORGANIZATION_DETAIL_TABS,
    initials: getInitials(organization.organizationName ?? ''),
    avatarColorClass: generateAvatarColorClass(organization.organizationName ?? ''),
    handleBack,
  };
};
